module.exports = __webpack_public_path__ + "img/factor_c_gray.58d75a81.svg";